module.exports = __webpack_public_path__ + "img/appAsset-brand--HubSpot.92349da8.svg";